import { Component, Mixins } from 'vue-property-decorator';
import { IS_NOT_FOUND_UPDATED } from '@gig/magic-messages';
import { ISubscription } from '@gig/magic-message-bus/dist/base-bus';

@Component
export class NotFoundMixin extends Mixins() {
    isNotFound: boolean = false;

    private isNotFoundSubscription: ISubscription | null = null;

    created() {
        this.isNotFoundSubscription = window.eventBus.subscribe<boolean>(
            IS_NOT_FOUND_UPDATED,
            (e) => {
                this.isNotFound = e.payload ?? false;
            },
            { replay: true },
        );
    }

    destroyed() {
        this.isNotFoundSubscription?.unsubscribe();
    }
    /**
     * Triggered every time the route changes, we want to reset the not-found state
     * so that, in case the user was on the 404 page because of the store being
     * in 'not-found' state, the user can navigate away and not get stuck into
     * 404 page
     */
    resetNotFound() {
        window.eventBus.publish<boolean>(IS_NOT_FOUND_UPDATED, false);
    }

    setIsNotFound() {
        window.eventBus.publish<boolean>(IS_NOT_FOUND_UPDATED, true);
    }
}
